<div
  id="listing-details-wrapper"
  class="flex flex-col gap-4 scroll-m-100"
  [style.paddingBottom]="bottomPadding()"
>
  <div class="grid lg:grid-cols-[1fr_310px] gap-4">
    <main class="flex flex-col gap-4">
      @if (listing().saleType === 'homesite') {
        <app-homesite-listing-details [listing]="listing()" class="flex flex-col gap-4" />
      } @else if (listing().saleType) {
        <app-home-listing-details
          [listing]="listing()"
          class="flex flex-col gap-4"
          (openGalleryClicked)="openGallery($event)"
          (openMapClicked)="openMap()"
          (openTourClicked)="openTour()"
        />
      }
    </main>

    <app-listing-details-sidebar
      class="flex flex-col gap-4"
      [listing]="listing()"
      (setRepFilter)="setRepFilter.emit($event)"
    />
  </div>

  <app-listing-details-cta />
</div>

<app-lightbox
  [images]="listing().images ?? []"
  [youtubeId]="listing().youtubeId"
  [hasMap]="!!listing().geo"
  [listingId]="listing().id!"
  (closedAt)="onLightboxClosed($event)"
/>
